import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Frimware } from 'src/app/models/tv/tv';
import { AccountService } from 'src/app/services/account/account.service';
import { TvService } from 'src/app/services/tv/tv.service';

@Component({
  selector: 'app-firmware',
  templateUrl: './firmware.component.html',
  styleUrls: ['./firmware.component.scss'],
})
export class FirmwareComponent implements OnInit {
  firmwares: Array<Frimware> = [];
  contextmenu: string;
  contextmenuX = 0;
  contextmenuY = 0;
  copiedElement;
  contextElement;
  searchValue: string;
  firmwareToDelete;

  constructor(
    private tvService: TvService,
    private router: Router,
    public accountService: AccountService
  ) {}

  ngOnInit(): void {
    this.getFirmwares();
  }

  getFirmwares() {
    this.tvService.getFirmwares().subscribe((data) => {
      this.firmwares = data;
    });
  }

  editFirmware(id) {
    this.router.navigate(['editFirmware'], { queryParams: { id } });
  }

  deleteFirmware() {
    this.tvService
      .deleteFirmware(this.firmwareToDelete.id)
      .subscribe(() => {
        this.getFirmwares();
      });
  }

  //activates the menu with the coordinates
  onrightClick(event, element?, project?) {
    this.contextmenuX = event.clientX;
    this.contextmenuY = event.clientY;
    console.log('context menu', element);
    if (element) this.contextmenu = 'copy';
    else this.contextmenu = 'paste';
    this.contextElement = element;
    if (this.contextElement) {
      this.contextElement.vendor = localStorage.getItem('HechRomeoAccount');
      if (project) this.contextElement.project = true;
    }
  }

  disableContextMenu() {
    this.contextmenu = undefined;
  }
}
